import { render, staticRenderFns } from "./TableDeliveryOrderView.vue?vue&type=template&id=700c013b&scoped=true&"
import script from "./TableDeliveryOrderView.vue?vue&type=script&lang=js&"
export * from "./TableDeliveryOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c013b",
  null
  
)

export default component.exports